var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_823_354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_823_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.025C11.8832 15.025 11.7709 15.004 11.6629 14.962C11.5542 14.9207 11.4582 14.8583 11.3749 14.775L6.8749 10.275C6.7249 10.125 6.6499 9.95 6.6499 9.75C6.6499 9.55 6.7249 9.375 6.8749 9.225C7.0249 9.075 7.1999 9 7.3999 9C7.5999 9 7.7749 9.075 7.9249 9.225L11.9999 13.3L16.0749 9.225C16.2249 9.075 16.3999 9 16.5999 9C16.7999 9 16.9749 9.075 17.1249 9.225C17.2749 9.375 17.3499 9.55 17.3499 9.75C17.3499 9.95 17.2749 10.125 17.1249 10.275L12.6249 14.775C12.5416 14.8583 12.4459 14.9207 12.3379 14.962C12.2292 15.004 12.1166 15.025 11.9999 15.025Z",
    fill: "#81878C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.1f56fde2ac2ababeb9b8d0fdb2846c15.svg";
export { ForwardRef as ReactComponent };